import Watermark from './src/watermark.mjs';
export { watermarkProps } from './src/watermark2.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElWatermark = withInstall(Watermark);

export { ElWatermark, ElWatermark as default };
//# sourceMappingURL=index.mjs.map
